import ProjectContentCss from "components/front/layout/ProjectContentCss";
import SwiperCss from "components/front/layout/SwiperCss";
import { createGlobalStyle } from "styled-components";
import AccordionCss from "components/front/layout/AccordionCss";

const ProjectContentStyle = createGlobalStyle`
  ${ProjectContentCss}
  .content-swiper {
    ${SwiperCss};
  }
  ${AccordionCss}
`;
export default ProjectContentStyle;
